import React from "react";

const formatFullName = (client = {}) => {
  const parts = [client?.prenom, client?.nom].filter(Boolean);
  if (parts.length) return parts.join(" ");
  if (client?.email) return client.email;
  if (client?.telephone) return client.telephone;
  return "ce client";
};

const formatDateLabel = (value) => {
  if (!value) return "cette date";
  const dateObj = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dateObj.getTime())) return "cette date";
  return dateObj.toLocaleDateString("fr-FR", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const formatHourLabel = (reservation = {}) => {
  const raw =
    reservation?.creneau_heure_debut ??
    reservation?.heure_debut ??
    reservation?.creneau?.heure ??
    reservation?.heure;

  if (!raw) return "cet horaire";
  const date = new Date(`1970-01-01T${raw}`);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

const DeleteReservationModal = ({
  open,
  reservation,
  onCancel,
  onConfirm,
  loading = false,
  errorMessage = "",
  comment = "",
  onCommentChange,
}) => {
  if (!open || !reservation) return null;

  const clientName = formatFullName(reservation?.client_data);
  const dateLabel = formatDateLabel(reservation?.date_atelier);
  const hourLabel = formatHourLabel(reservation);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6 space-y-4">
        <div>
          <h3 className="text-2xl font-semibold text-slate-900">
            Confirmer la suppression
          </h3>
          <p className="text-slate-600 mt-2">
            Êtes-vous sûr de vouloir annuler la réservation de{" "}
            <span className="font-semibold text-slate-900">{clientName}</span>{" "}
            prévue le <span className="font-semibold text-slate-900">{dateLabel}</span>{" "}
            à <span className="font-semibold text-slate-900">{hourLabel}</span> ?
          </p>
        </div>

        {errorMessage && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2">
            {errorMessage}
          </div>
        )}

        <div>
          <label
            htmlFor="delete-reservation-comment"
            className="block text-sm font-medium text-slate-600 mb-2"
          >
            Commentaire (optionnel)
          </label>
          <textarea
            id="delete-reservation-comment"
            rows={3}
            value={comment}
            onChange={(event) => onCommentChange?.(event.target.value)}
            placeholder="Ajouter un commentaire pour cette suppression"
            className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-red-200 resize-none"
          />
        </div>

        <form
          className="flex justify-end gap-3 pt-2"
          onSubmit={(event) => {
            event.preventDefault();
            onConfirm?.();
          }}
        >
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 rounded-lg border border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-400 transition disabled:opacity-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 rounded-lg bg-red-600 text-white font-semibold hover:bg-red-700 transition disabled:opacity-60"
          >
            {loading ? "Suppression..." : "Valider"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DeleteReservationModal;
